import React from 'react'
import ExpenseRequirements from 'src/app/ExpenseRequirements/ExpenseRequirements'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import ExpenseRequirementsAdditionalFieldsAppRoute from 'src/navigation/appRoutes/organization/expenseRequirementsAdditionalFields.appRoute'
import ExpenseRequirementsReceiptRulesAppRoute from 'src/navigation/appRoutes/organization/expenseRequirementsReceiptRules.appRoute'
import { expenseRequirementsRouteProps } from 'src/navigation/routeProps'

const ExpenseRequirementsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseRequirements,
  routeProps: expenseRequirementsRouteProps,
  component: <ExpenseRequirements />,
  subRoutes: [
    ExpenseRequirementsReceiptRulesAppRoute,
    ExpenseRequirementsAdditionalFieldsAppRoute,
  ],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseRequirementsAppRoute
